// 2. auditLogService.ts
import { BaseService } from "./baseService";
import { AuditLogDto } from "../types/auditLog"; // Βεβαιώσου ότι το path είναι σωστό

class AuditLogService extends BaseService<AuditLogDto> {
  constructor() {
    super("/AuditLog");
  }
}

export const auditLogService = new AuditLogService();